import { useState } from "react";

interface FloatingContactProps {
  onInspectionClick: () => void;
}

export default function FloatingContact({ onInspectionClick }: FloatingContactProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-5 z-50 flex flex-col items-end gap-3">
      {/* Expanded options */}
      {open && (
        <div className="flex flex-col gap-2 items-end">
          {/* Call */}
          <a
            href="tel:5617745120"
            className="flex items-center gap-3 bg-[#0a0e1a] border border-[#1a3a5c]/60 text-white text-sm font-semibold px-4 py-3 rounded-full shadow-lg hover:bg-[#1a3a5c] transition-colors whitespace-nowrap cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-[#4a7fa5]"></i>
            </span>
            (561) 774-5120
          </a>

          {/* Email */}
          <a
            href="mailto:info@clwizard.com"
            className="flex items-center gap-3 bg-[#0a0e1a] border border-[#1a3a5c]/60 text-white text-sm font-semibold px-4 py-3 rounded-full shadow-lg hover:bg-[#1a3a5c] transition-colors whitespace-nowrap cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-mail-fill text-[#4a7fa5]"></i>
            </span>
            info@clwizard.com
          </a>

          {/* Free Inspection */}
          <button
            onClick={() => { setOpen(false); onInspectionClick(); }}
            className="flex items-center gap-3 bg-[#1a3a5c] text-white text-sm font-bold px-4 py-3 rounded-full shadow-lg hover:bg-[#0f2a45] transition-colors whitespace-nowrap cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-calendar-check-fill text-white"></i>
            </span>
            Free Inspection
          </button>
        </div>
      )}

      {/* Main toggle button */}
      <button
        onClick={() => setOpen(!open)}
        className="w-14 h-14 flex items-center justify-center rounded-full bg-[#1a3a5c] hover:bg-[#0f2a45] text-white shadow-xl transition-all duration-300 cursor-pointer border-2 border-[#4a7fa5]/40"
        aria-label="Contact options"
      >
        <span className="w-7 h-7 flex items-center justify-center">
          <i className={`text-2xl transition-transform duration-300 ${open ? "ri-close-line" : "ri-customer-service-2-fill"}`}></i>
        </span>
      </button>
    </div>
  );
}
